document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav toggle
  var navToggle = document.querySelector('.mobile-nav-toggle');
  var mainNav = document.querySelector('.main-nav');
  if (navToggle && mainNav) {
    navToggle.addEventListener('click', function () {
      mainNav.classList.toggle('nav-open');
    });
  }

  // Product gallery thumbnail swap
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mainImg = document.querySelector('[data-main-media]');
      if (mainImg) mainImg.setAttribute('src', thumb.getAttribute('data-full'));
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // Variant swatch selection
  document.querySelectorAll('[data-swatch]').forEach(function (swatch) {
    swatch.addEventListener('click', function () {
      document.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('active'); });
      swatch.classList.add('active');
    });
  });

  // Quantity selector
  document.querySelectorAll('.qty-selector').forEach(function (selector) {
    var input = selector.querySelector('input');
    var minus = selector.querySelector('[data-qty-minus]');
    var plus = selector.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // Accordion (native <details> already handles open/close, this is just for single-open behavior)
  document.querySelectorAll('.product-accordion .accordion-item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        document.querySelectorAll('.product-accordion .accordion-item').forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  }, true);

});
